import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ClipboardService } from "@merri/common";
import { RedirectService, SnackBarService } from "src/app/core";
import { ShowroomService } from "../../../services";

@Component({
    selector: "app-showroom-guest-link-dialog",
    templateUrl: "./showroom-guest-link-dialog.component.html",
    styleUrls: ["./showroom-guest-link-dialog.component.scss"],
    standalone: false
})
export class ShowroomGuestLinkDialogComponent implements OnInit {
  link: string;

  constructor(
    private _dialog: MatDialogRef<ShowroomGuestLinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private clipboardService: ClipboardService,
    private snackBarService: SnackBarService,
    private showroomService: ShowroomService,
    private _redirectService: RedirectService,
  ) {}

  onClose(): void {
    this._close();
  }

  ngOnInit(): void {
    this.link = this.showroomService.getShowroomPublicPageUrl(this.data, true);
  }

  onCopyClick(): void {
    this.clipboardService.copyToClipboard(this.link);
    this.snackBarService.show({ message: "Guest link copied to clipboard", action: "Hide", duration: 3000 });
  }

  onOpenInNewTabClick(): void {
    this._redirectService.redirectExternal(this.link, "_blank");
  }

  private _close(): void {
    this._dialog.close();
  }
}
